<template>
  <div>
    <!-- 标题 -->
    <h3 v-if="title">{{ title }}</h3>

    <Row
      :gutter="8"
      style="margin: 10px 0 0 0; width: 100%"
      v-if="filters && filters.length > 0"
    >
      <Collapse style="width: 100%" v-model="value1">
        <Panel style="width: 100%" name="1">
          展开搜索条件
          <Form
            ref="formQuery"
            :label-width="80"
            :label-position="left"
            :label-colon="true"
            :model="query"
            style="
              display: flex;
              flex-direction: row-reverse;
              justify-content: flex-end;
              flex-wrap: wrap;
              width: 80%;
              margin-top: 10px;
            "
            slot="content"
          >
            <Col
              span="3"
              :xxl="6"
              :xl="4"
              :lg="6"
              :md="8"
              :sm="12"
              :xs="24"
              style="
                display: flex;
                flex-direction: row-reverse;
                position: absolute;
                right: 20px;
              "
            >
              <Button
                icon="ios-search"
                type="info"
                @click="search"
                style="width: 90px"
                >搜索
              </Button>
              <Button
                icon="ios-close-circle"
                type="error"
                @click="clearFilter"
                style="width: 90px; margin-right: 15px"
              >
                重置
              </Button>
            </Col>
            <template v-for="(v, k) in filters">
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-if="v.type === 'inputs'"
                style="margin: 0px 0 10px 0; float: right; display: flex"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <div style="margin-bottom: 0; display: flex">
                    <Input
                      :key="k"
                      :placeholder="'最小' + v.label"
                      clearable
                      v-model="query[v.name1]"
                    ></Input>
                    <div>~</div>
                    <Input
                      :key="k"
                      :placeholder="'最大' + v.label"
                      clearable
                      v-model="query[v.name2]"
                    ></Input>
                  </div>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-if="
                  v.type === 'string' || v.type === 'text' || v.type === 'input'
                "
                style="margin: 0px 0 10px 0; float: right; display: flex"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <Input
                    :key="k"
                    :placeholder="v.label"
                    clearable
                    v-model="query[v.name]"
                    @keyup.enter.native="v.KeyEnter"
                  ></Input>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'select'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <i-select
                    :key="k"
                    v-model="query[v.name]"
                    clearable
                    style="width: 193px"
                    @keyup.enter.native="v.KeyEnter"
                    :multiple="v.multiple ? true : false"
                    :disabled="v.disabled ? true : false"
                    :placeholder="v.label"
                    :filterable="true"
                    @on-change="v.onChange"
                  >
                    <Option
                      :value="s.value"
                      v-for="(s, sk) in v.dropList || []"
                      :key="sk"
                      >{{ s.name }}
                    </Option>
                  </i-select>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'selectsearch'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <i-select
                    :key="k"
                    v-model="query[v.name]"
                    clearable
                    remote
                    filterable
                    @keyup.enter.native="v.KeyEnter"
                    :remote-method="v.remoteMethod"
                    style="width: 193px"
                    :multiple="v.multiple ? true : false"
                    :disabled="v.disabled ? true : false"
                    :placeholder="v.label"
                    @on-change="v.onChange"
                  >
                    <Option
                      :value="s.value"
                      v-for="(s, sk) in v.dropList || []"
                      :key="sk"
                      >{{ s.name }}
                    </Option>
                  </i-select>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'datetimerange'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <DatePicker
                    clearable
                    :key="k"
                    type="daterange"
                    v-model="query1[v.name + v.lable]"
                    style="width: 193px"
                    @keyup.enter.native="v.KeyEnter"
                    format="yyyy-MM-dd"
                    placeholder="选择时间"
                    :options="optionsData"
                    @on-change="
                      (val) => {
                        timeDateChange(val, v.name);
                      }
                    "
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col
                :key="k"
                v-else-if="v.type === 'distpicker'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormAddress
                  @on-change="
                    (val) => {
                      onAddressChange(val, v.name);
                    }
                  "
                  style="width: 100%"
                ></FormAddress>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'addressInfo'"
                style="width: auto; margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <v-distpicker
                    :disabeld="disabeld"
                    type="addressInfo"
                    :province="province"
                    :city="city"
                    :area="area"
                    @selected="v.onSelect"
                  ></v-distpicker>
                </FormItem>
              </Col>
            </template>
          </Form>
        </Panel>
      </Collapse>
    </Row>

    <div class="Seats">
      <p class="zuoxi">坐席设置:</p>
      <div class="Seatsbox">
        <!-- 
          <RadioGroup
          v-model="SeatsList"
          type="button"
          button-style="solid"
          @on-change="click"
        >
          <Radio v-for="item in Seats" :label="item" :key="item">{{ item }}</Radio>
        </RadioGroup>
         -->
        <el-checkbox-group v-model="SeatsList" size="small" @change="click">
          <el-checkbox-button v-for="item in Seats" :label="item" :key="item"
            >{{ item }}
          </el-checkbox-button>
        </el-checkbox-group>
      </div>
    </div>
    <!-- 表格 -->
    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%">
      <edit-table
        ref="tablelist"
        :query="query"
        :table="table"
        :order="table.order || ''"
        :rowClassName="table.rowClassName"
        :output="table.output"
        :border="table.border"
        :stripe="table.stripe"
        :header="table.header"
        :footer="table.footer"
        :columns-list="tableCols"
        :handleSpan="handleSpan"
        @on-select="handleSelect"
        @on-edit="handleEdit"
        @on-info="handleInfo"
        @on-del="handleDel"
      >
        <div slot="header">
          <tableHeader></tableHeader>
        </div>
        <div slot="action" v-if="tactions && tactions.length > 0">
          <div
            v-for="(v, k) in tactions"
            :key="k"
            style="margin-right: 10px; display: inline-flex"
          >
            <Button
              :size="v.size || 'default'"
              :type="v.type || 'primary'"
              v-auth="v.auth"
              :icon="v.icon || ''"
              :disabled="v.disabled"
              @click="v.onClick"
              >{{ v.label }}
            </Button>
          </div>
        </div>
        <div slot="footer">
          <tableFooter></tableFooter>
        </div>
      </edit-table>
      <!-- <Badge   v-if="hospitaltype=='购物车'" :count="num" style="margin-top: 50px" > <Button @click="handleSubmit" style="background: #00c261;color: #f8f8f9;">提交申请</Button></Badge> -->
    </Row>
    <!-- 动态组件 -->
    <component
      v-for="(item, index) in extRender || []"
      :key="index"
      :ref="item"
      :is="item"
    ></component>
  </div>
</template>

<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Calling from "./calling.vue";
import modalEdit from "./modalEdit.vue";

export default {
  extends: baseList,
  components: { modalEdit },
  data() {
    return {
      SeatsList: [], //默认选中列表
      Seats: [], //坐席列表
      channelId: false,
      form: {},
      forms: {},
      table: {
        mname: "callcenter",
        key: "id",
        url: {},
        output: false,
        order: "starttime",
      },
      value1: "0",
      query: {},
      filters: [
        {
          label: "来电号码",
          KeyEnter: this.search,
          name: "callno",
          value: "",
          type: "input",
        },
        {
          label: "接听状态",
          name: "callState",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: "0",
              name: "已接听",
            },
            {
              value: "1",
              name: "未接听",
            },
          ],
        },
        {
          label: "工单类型",
          name: "typeId",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
        {
          label: "来电时间",
          KeyEnter: this.search,
          name: "starttime",
          value: "",
          type: "datetimerange",
        },
        {
          label: "科室",
          name: "deskName",
          value: "",
          KeyEnter: this.search,
          type: "input",
          // remoteMethod: this.deskChange,
        },
        {
          label: "处理状态",
          name: "creation",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: "0",
              name: "未建单",
            },
            {
              value: "1",
              name: "待处理",
            },
            {
              value: "2",
              name: "处理中",
            },
            {
              value: "3",
              name: "已完成",
            },
          ],
        },
        {
          name: "channelIds",
          value: "",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "来电时间",
          key: "starttime",
          width: 200,
          align: "center",
        },

        {
          title: "呼入/呼出号码",
          minWidth: 160,
          align: "center",
          key: "calltype",
          render: (h, params) => {
            const row = params.row;
            const text1 =
              row.calltype === "0"
                ? "呼入"
                : row.calltype === "1"
                ? "呼出"
                : "";
            const text = row.callno;
            return h(
              "div",
              {
                style: {
                  margin: "5px",
                  "font-size": "14px",
                  width: "150px",
                  // overflow: 'hidden',
                  // 'text-overflow': 'ellipsis',
                  // 'white-space': 'nowrap',
                },
              },
              text1 + text
            );
          },
        },
        {
          title: "来电科室",
          key: "department",
          width: 200,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const isImportant = row.isImportant;
            return (
              <div>
                <modalEdit
                  onResetList={this.resetList}
                  isImportant={isImportant}
                  row={row}
                  branchList={this.branchList}
                />
              </div>
            );
          },
        },
        {
          title: "接听状态",
          key: "state",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state == 0 ? "已接听" : row.state == 1 ? "未接听" : "";
            return h(
              "div",
              {
                style: {
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        /*  {
          title: "工单类型",
          key: "typeName",
          minWidth: 100,
          align: "center",
          tooltip: "true",
        }, */
        {
          title: "处理状态",
          key: "creation",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.creation == 0
                ? "未建单"
                : row.creation == 1
                ? "待处理"
                : row.creation == 2
                ? "处理中"
                : row.creation == 3
                ? "已完成"
                : "";
            return h(
              "div",
              {
                style: {
                  color:
                    row.creation == 0
                      ? "red"
                      : row.creation == 1
                      ? "orange"
                      : row.creation == 2
                      ? "blue"
                      : row.creation == 3
                      ? "green"
                      : "",
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "结束时间",
          key: "endtime",
          width: 200,
          align: "center",
        },
        {
          title: "通话时长(秒)",
          key: "duration",
          minWidth: 120,
          align: "center",
        },
        {
          title: "录音文件",
          minWidth: 100,
          key: "recordfile",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small",
                    type: "info",
                  },
                  style: {
                    margin: "0 5px",
                  },
                  // 自定义指令

                  on: {
                    click: () => {
                      console.log(row);
                      console.log(row.recordfile);
                      let left = (window.screen.width - 300) / 2;
                      let top = (window.screen.height - 200) / 3;
                      window.open(
                        row.recordfile,
                        "_newAutioBox",
                        `width=300,height=200,left=${left},top=${top},menubar=no,toolbar=no,status=no,scrollbars=yes`
                      );
                    },
                  },
                },
                "播放"
              ),
            ]);
          },
        },
        {
          title: "操作",
          align: "center",
          minWidth: 130,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              let row = param.row;
              // let directives = []
              let directives = [
                { name: "auth", value: "/admin/callcenter/edit" },
              ];
              if (row.creation === 0) {
                return (
                  <Button
                    {...{ directives }}
                    size="small"
                    onClick={() => this.toAlert(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginRight: "5px",
                    }}
                  >
                    建单
                  </Button>
                );
              }
            },
            // (vm, h, currentRow, param) => {
            //   let row = param.row;
            //   return (
            //     <Button
            //       size="small"
            //       onClick={() => this.toAlert(currentRow)}
            //       type="default"
            //       style={{
            //         border: "none",
            //         color: "#4991ff",
            //         marginRight: "5px",
            //       }}
            //     >
            //       弹屏
            //     </Button>
            //   );
            // },
            (vm, h, currentRow, param) => {
              let row = param.row;
              // let directives = []
              let directives = [
                { name: "auth", value: "/admin/callcenter/solve" },
              ];
              if (row.creation != 0) {
                return (
                  <Button
                    {...{ directives }}
                    size="small"
                    onClick={() => this.workinfo(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                    }}
                  >
                    详情
                  </Button>
                );
              }
            },
          ],
        },
      ],
      optionsData: {
        disabledDate(date) {
          return date && date.valueOf() >= new Date();
        },
        shortcuts: [
          {
            text: "本周",
            value() {
              const end = new Date();
              const start = new Date();
              const weekday = start.getDay() || 7; //获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7
              start.setDate(start.getDate() - weekday + 1); //往前算（weekday-1）天，年份、月份会自动变化
              return [start, end];
            },
          },
          {
            text: "本月",
            value() {
              const end = new Date();
              var nowMonth = end.getMonth(); //当前月
              var nowYear = end.getFullYear(); //当前年
              const start = new Date(nowYear, nowMonth, 1);
              return [start, end];
            },
          },
          {
            text: "上个月",
            value() {
              const data = new Date();
              var nowMonth = data.getMonth(); //当前月
              var nowYear = data.getFullYear(); //当前年
              const start = new Date(nowYear, nowMonth - 1, 1);
              const end = new Date(nowYear, nowMonth, 0);
              return [start, end];
            },
          },
        ],
      },
      callactions: [],
      branchList: [],
    };
  },
  async created() {
    await this.seats();
    await this.pitch();
    await this.search();
    this.initDatas();
    this.loadLevelDatas();
    this.getBranch();
    // await this.deskListMethod()
  },
  mounted() {},
  methods: {
    resetList() {
      this.search();
    },
    toAlert(row) {
      this.$Modal.success({
        closable: true,
        width: "1200px",
        // okButtonProps:{ style: { display: 'none' } },
        // footerHide: true,
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Calling
              style={{ margin: "0", color: "#19be6b" }}
              deskId={row.deskId}
              phone={row.callno}
              callId={row.id}
            ></Calling>
          );
        },
      });
    },
    //修改选中坐席
    async click(val) {
      let channelIds = [];
      for (let i = 0; i < val.length; i++) {
        let a = String(val[i]);
        /*   if (val[0] == "一号坐席") {
          val.splice(i, 1);
          i--;
        } else {
        } */
        channelIds.push(a);
      }
      let q = {
        channelNames: channelIds,
      };

      console.log(666, q);
      let res = await $utils.api.load(
        `/admin/system/user/changeCall`,
        q,
        "post"
      );
      if (res) {
        // console.log(res);
      }
      (this.query.channelIds = q.channelNames.toString()), this.search();
    },
    //坐席设置
    async seats() {
      // 加载详情数据
      let res = await $utils.api.load(`/admin/system/callConfig/list`);
      if (res && res.rows) {
        let arr = res.rows;
        arr.map((item) => {
          let obj = {
            value: item.channelId,
            name: item.channelName,
          };
          this.Seats.push(obj.name);
        });
      }
    },
    //坐席默认选中数据
    async pitch() {
      let res = await $utils.api.load(`/admin/system/user/getUserInfo`);
      if (res && res.data) {
        let arr = res.data;
        this.SeatsList = arr.channelNames;
        this.filters[6].value = this.SeatsList.toString();
        this.query = {
          channelIds: this.filters[6].value,
        };
      }
    },

    // async deskListMethod() {
    //   let res = await $utils.api.load("/admin/system/desk/selectList");
    //   if (res && res.rows) {
    //     let ll = res.rows;
    //     let dropList = [];
    //     for (let index = 0; index < ll.length; index++) {
    //       const element = ll[index];
    //       let xx = {};
    //       xx.value = element.id;
    //       xx.name = element.deskName;
    //       xx.children = element.children || [];
    //       dropList.push(xx);
    //     }
    //     for (let index = 0; index < this.filters.length; index++) {
    //       const element = this.filters[index];
    //       if (element && element.name == "deskId") {
    //         this.filters[index]["dropList"] = dropList;
    //       }
    //     }
    //   }
    // },
    // //科室搜索
    // deskChange(query) {
    //   if (query !== "") {
    //     setTimeout(async () => {
    //       let q = {
    //         deskName: query,
    //       };
    //       $utils.api
    //           .load(`/admin/system/desk/selectList`, q, "get")
    //           .then((res) => {
    //             const list = res.rows.map((item) => {
    //               return {
    //                 value: item.id,
    //                 name: item.deskName,
    //               };
    //             });
    //             for (let index = 0; index < this.filters.length; index++) {
    //               const element = this.filters[index];
    //               if (element && element.name == "deskId") {
    //                 this.filters[index]["dropList"] = list;
    //               }
    //             }
    //           });
    //     }, 200);
    //   } else {
    //     this.dropList = [];
    //   }
    // },
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/workType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeId") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    tochangeseats() {
      $utils.url.push({ name: "callseats" });
    },
    workinfo(row) {
      $utils.url.push({
        name: "workOrder_info",
        query: { action: "edit", kv: row.workId, workId: row.workId },
      });
    },
    towork(row) {
      $utils.url.push({
        name: "workOrder_add",
        query: {
          action: "add",
          cv: "flash",
          phone: row.callno,
          kv: row.id,
          msgkv: "callCenter",
        },
      });
    },
    laidian() {
      this.$Modal.success({
        closable: true,
        width: "1000px",
        // okButtonProps:{ style: { display: 'none' } },
        // footerHide: true,
        okText: "取消",
        showOk: false,
        render: (h) => {
          return <Calling style={{ margin: "0", color: "#19be6b" }}></Calling>;
        },
      });
    },
    //详情
    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info",
        query: { action: "edit", callId: row.id },
      });
    },
    initDatas() {
      // 加载详情数据
      $utils.api.load(`/admin/system/record/statistics`, {}).then((res) => {
        if (res && res.data) {
          this.forms.history = res.data.history;
          this.forms.today = res.data.today;
          this.forms.month = res.data.month;
          this.title =
            "来电总数:" +
            this.forms.history +
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0" +
            "本月来电" +
            this.forms.month +
            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0" +
            "今日来电:" +
            this.forms.today;
        }
      });
    },
    async getBranch() {
      let d = {};
      let res = await $utils.api.load("admin/system/desk/list", d, "get");
      if (res.code == 200) {
        this.branchList = res.rows;
      }
      // console.log(res);
    },
  },
};
</script>

<style lang="less" scoped>
.Seats {
  height: 30px;
  position: relative;
  margin-top: 10px;

  .zuoxi {
    position: absolute;
    left: 5px;
    top: 5px;
  }

  .Seatsbox {
    position: absolute;
    left: 79px;
  }
}
</style>
